<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CX833、CX961、CX962、CX963、XC8355、XC9635、XC9645、XC9655 多功能複合機">
     CX833、CX961、CX962、CX963、XC8355、XC9635、XC9645、XC9655 多功能複合機
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_tc" title="安全資訊">
     安全資訊
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="慣例">
      慣例
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e43" title="產品聲明">
      產品聲明
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_tc" title="瞭解印表機">
     瞭解印表機
    </a>
   </p>
   <div id="divd0e221">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_tc" title="尋找印表機相關資訊">
      尋找印表機相關資訊
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_tc" title="尋找印表機序號">
      尋找印表機序號
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_tc" title="印表機配置">
      印表機配置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_tc" title="使用控制面板">
      使用控制面板
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_tc" title="主畫面圖示">
      主畫面圖示
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_tc" title="指示燈燈色">
      指示燈燈色
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_tc" title="使用自動送稿器或掃描器玻璃面板">
      使用自動送稿器或掃描器玻璃面板
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_tc" title="尋找安全插孔">
      尋找安全插孔
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e769" title="選取紙張">
      選取紙張
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10635" title="其他印表機功能與支援">
      其他印表機功能與支援
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_tc" title="設定、安裝和配置">
     設定、安裝和配置
    </a>
   </p>
   <div id="divd0e10762">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_tc" title="選取印表機放置地點">
      選取印表機放置地點
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_tc" title="印表機連接埠">
      印表機連接埠
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-scan-center-topic.html#d0e10961" title="配置應用程式與解決方案">
      配置應用程式與解決方案
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e11138" title="設定與使用協助工具功能">
      設定與使用協助工具功能
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e11443" title="設定印表機傳真功能">
      設定印表機傳真功能
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_tc" title="載入紙張和特殊材質">
      載入紙張和特殊材質
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e12239" title="安裝與更新軟體、驅動程式和韌體">
      安裝與更新軟體、驅動程式和韌體
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e12565" title="安裝硬體選購品">
      安裝硬體選購品
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e14096" title="網路">
      網路
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_tc" title="進行印表機安全防護">
     進行印表機安全防護
    </a>
   </p>
   <div id="divd0e14448">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_tc" title="清除印表機記憶體">
      清除印表機記憶體
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_tc" title="清除印表機儲存磁碟機">
      清除印表機儲存磁碟機
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_tc" title="回復出廠預設值設定">
      回復出廠預設值設定
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_tc" title="揮發性聲明">
      揮發性聲明
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_tc" title="列印">
     列印
    </a>
   </p>
   <div id="divd0e14640">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_tc" title="從電腦列印">
      從電腦列印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14691" title="從行動裝置列印">
      從行動裝置列印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_tc" title="從快閃硬碟列印">
      從快閃硬碟列印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_tc" title="配置機密工作">
      配置機密工作
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_tc" title="列印機密工作和其他保留工作">
      列印機密工作和其他保留工作
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_tc" title="列印字型範例清單">
      列印字型範例清單
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_tc" title="列印目錄清單">
      列印目錄清單
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_tc" title="在列印工作中放置分隔頁">
      在列印工作中放置分隔頁
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_tc" title="取消列印工作">
      取消列印工作
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_tc" title="調整碳粉明暗度">
      調整碳粉明暗度
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_tc" title="複印">
     複印
    </a>
   </p>
   <div id="divd0e15186">
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_tc" title="進行複印">
      進行複印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_tc" title="複印相片">
      複印相片
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-letterhead-topic.html#copying-on-letterhead_tc" title="複印在信頭紙上">
      複印在信頭紙上
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_tc" title="複印在紙張的正反面">
      複印在紙張的正反面
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_tc" title="縮小或放大複印文件">
      縮小或放大複印文件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_tc" title="逐份列印份數">
      逐份列印份數
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_tc" title="在列印副本之間放置分隔頁">
      在列印副本之間放置分隔頁
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_tc" title="將多頁複印在一張紙上">
      將多頁複印在一張紙上
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_tc" title="複印證件">
      複印證件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_tc" title="建立複印快捷鍵">
      建立複印快捷鍵
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_tc" title="電子郵件">
     電子郵件
    </a>
   </p>
   <div id="divd0e15459">
    <p class="toc-2-style">
     <a href="configuring-smtp-settings-topic.html#configuring-smtp-settings_tc" title="配置 SMTP 設定">
      配置 SMTP 設定
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_tc" title="傳送為電子郵件">
      傳送為電子郵件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_tc" title="建立電子郵件快捷鍵">
      建立電子郵件快捷鍵
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_tc" title="傳真">
     傳真
    </a>
   </p>
   <div id="divd0e16908">
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_tc" title="傳送傳真">
      傳送傳真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_tc" title="排定傳真的時程">
      排定傳真的時程
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_tc" title="建立傳真目的地快捷鍵">
      建立傳真目的地快捷鍵
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_tc" title="變更傳真解析度">
      變更傳真解析度
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_tc" title="調整傳真明暗度">
      調整傳真明暗度
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_tc" title="列印傳真日誌">
      列印傳真日誌
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_tc" title="封鎖垃圾傳真">
      封鎖垃圾傳真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_tc" title="保留傳真">
      保留傳真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_tc" title="轉發傳真">
      轉發傳真
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_tc" title="掃描">
     掃描
    </a>
   </p>
   <div id="divd0e17204">
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_tc" title="掃描至電腦">
      掃描至電腦
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_tc" title="掃描到 FTP 伺服器">
      掃描到 FTP 伺服器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_tc" title="建立 FTP 快捷鍵">
      建立 FTP 快捷鍵
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-network-folder-topic.html#scanning-to-network-folder_tc" title="掃描至網路資料夾">
      掃描至網路資料夾
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-network-folder-destination-topic.html#configuring-network-folder-destination_tc" title="配置網路資料夾目的地">
      配置網路資料夾目的地
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_tc" title="建立網路資料夾快捷鍵">
      建立網路資料夾快捷鍵
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_tc" title="掃描至快閃硬碟">
      掃描至快閃硬碟
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_tc" title="印表機功能表">
     印表機功能表
    </a>
   </p>
   <div id="divd0e17493">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_tc" title="功能表圖">
      功能表圖
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e17807" title="裝置">
      裝置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e20041" title="列印">
      列印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e21323" title="紙張">
      紙張
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e21655" title="複印">
      複印
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e22214" title="傳真">
      傳真
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e24081" title="電子郵件">
      電子郵件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e25178" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e25884" title="USB 磁碟機">
      USB 磁碟機
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e26730" title="網路/連接埠">
      網路/連接埠
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e28881" title="安全性">
      安全性
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e29978" title="雲端服務">
      雲端服務
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e30035" title="報告">
      報告
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_tc" title="疑難排解">
      <strong>
       疑難排解
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_tc" title="表單合併">
      <strong>
       表單合併
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_tc" title="列印功能表設定頁">
      列印
      <strong>
       功能表設定頁
      </strong>
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_tc" title="印表機分頁裝訂器選購品">
     印表機分頁裝訂器選購品
    </a>
   </p>
   <div id="divd0e30518">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_tc" title="使用分頁裝訂器">
      使用分頁裝訂器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_tc" title="使用裝訂打孔分頁裝訂器">
      使用裝訂打孔分頁裝訂器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_tc" title="使用偏位堆紙器">
      使用偏位堆紙器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_tc" title="使用小冊子分頁裝訂器">
      使用小冊子分頁裝訂器
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_tc" title="使用具摺疊選購品的紙張傳輸">
      使用具摺疊選購品的紙張傳輸
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_tc" title="維護印表機">
     維護印表機
    </a>
   </p>
   <div id="divd0e30928">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_tc" title="檢查零件及耗材狀態">
      檢查零件及耗材狀態
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_tc" title="配置耗材通知">
      配置耗材通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_tc" title="設定電子郵件警示">
      設定電子郵件警示
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_tc" title="產生報告與日誌">
      產生報告與日誌
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_tc" title="訂購零件及耗材">
      訂購零件及耗材
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e31783" title="更換零件及耗材">
      更換零件及耗材
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e32407" title="清潔印表機零件">
      清潔印表機零件
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e32571" title="省電與省紙">
      省電與省紙
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_tc" title="將印表機移到其他地點">
      將印表機移到其他地點
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_tc" title="問題疑難排解">
     問題疑難排解
    </a>
   </p>
   <div id="divd0e32709">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_tc" title="列印品質問題">
      列印品質問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_tc" title="印表機錯誤碼">
      印表機錯誤碼
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_tc" title="列印問題">
      列印問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_tc" title="印表機沒有回應">
      印表機沒有回應
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_tc" title="無法讀取快閃硬碟">
      無法讀取快閃硬碟
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_tc" title="啟用 USB 連接埠">
      啟用 USB 連接埠
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_tc" title="清除夾紙">
      清除夾紙
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e36133" title="網路連線問題">
      網路連線問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e36226" title="硬體選購品的問題">
      硬體選購品的問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e36399" title="耗材問題">
      耗材問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e36547" title="送紙問題">
      送紙問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e36741" title="傳送電子郵件問題">
      傳送電子郵件問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e36796" title="傳真問題">
      傳真問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e37118" title="掃描問題">
      掃描問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e37536" title="色彩品質問題">
      色彩品質問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_tc" title="聯絡客戶支援中心">
      聯絡客戶支援中心
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_tc" title="回收和丟棄">
     回收和丟棄
    </a>
   </p>
   <div id="divd0e37762">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_tc" title="回收 Lexmark 產品">
      回收 Lexmark 產品
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_tc" title="回收 Lexmark 包裝">
      回收 Lexmark 包裝
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_tc" title="注意事項">
     注意事項
    </a>
   </p>
   <div id="divd0e37798">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37801" title="產品資訊">
      產品資訊
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37818" title="版本注意事項">
      版本注意事項
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_tc" title="商標">
      商標
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_tc" title="版權注意事項">
      版權注意事項
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#hot-surface-notice_tc" title="高溫警告標籤">
      高溫警告標籤
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_tc" title="噪音干擾程度 (Noise emission levels)">
      噪音干擾程度 (Noise emission levels)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37933" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_tc" title="產品丟棄處置">
      產品丟棄處置
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37967" title="環境保護署廢乾電池回收標誌注意事項">
      環境保護署廢乾電池回收標誌注意事項
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#bsmi-battery-notice_tc" title="經濟部標準檢驗局 (BSMI) 電池聲明">
      經濟部標準檢驗局 (BSMI) 電池聲明
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37978" title="BSMI RoHS information 限用物質含有情況標示">
      BSMI RoHS information 限用物質含有情況標示
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_tc" title="易受靜電傷害的注意事項">
      易受靜電傷害的注意事項
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_tc" title="ENERGY STAR（能源之星）">
      ENERGY STAR（能源之星）
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_tc" title="溫度資訊">
      溫度資訊
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_tc" title="雷射公告">
      雷射公告
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_tc" title="耗電量">
      耗電量
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38195" title="無線產品控管注意事項">
      無線產品控管注意事項
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_tc" title="組合元件注意事項">
      組合元件注意事項
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_tc" title="暴露於無線電頻輻射">
      暴露於無線電頻輻射
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38220" title="NCC Type Approval Devices NoticeLow-power Radio-frequency Devices Notice">
      NCC Type Approval Devices Notice
      <br/>
      Low-power Radio-frequency Devices Notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#federal-communications-commission-fcc-compliance-information-statement-2_tc" title="美國聯邦電信委員會 (FCC) 相容資訊聲明">
      美國聯邦電信委員會 (FCC) 相容資訊聲明
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38248" title="BSMI EMC 注意事項">
      BSMI EMC 注意事項
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_tc" title="無線電干擾注意事項">
      無線電干擾注意事項
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue